import React from 'react';
import { Check, X } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function WhoIsFor() {
  const isFor = ['Mamás exhaustas que ya no pueden más con la privación de sueño.', 'Mujeres que buscan un método respetuoso y humano, sin llanto prolongado.', 'Madres que vuelven a trabajar y necesitan estar alertas y funcionales.', 'Padres que quieren recuperar su habitación y sus noches de pareja.'];
  const notFor = ['Personas que buscan una solución mágica de una sola noche sin consistencia.', 'Quienes prefieren métodos autoritarios de dejar llorar al bebé por horas.'];
  return <section className="bg-beige py-24 px-6 md:px-12" data-id="element-151">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-152">
        <FadeIn direction="right" data-id="element-153">
          <div className="bg-white p-8 md:p-10 rounded-3xl shadow-sm h-full" data-id="element-154">
            <h3 className="text-3xl mb-8 text-brown" data-id="element-155">Esto es para vos si...</h3>
            <ul className="space-y-6" data-id="element-156">
              {isFor.map((item, i) => <li key={i} className="flex items-start space-x-4" data-id="element-157">
                  <div className="bg-green-100 p-1 rounded-full mt-1 flex-shrink-0" data-id="element-158">
                    <Check className="w-5 h-5 text-green-600" strokeWidth={3} data-id="element-159" />
                  </div>
                  <span className="text-lg text-brown/80" data-id="element-160">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn direction="left" delay={0.2} data-id="element-161">
          <div className="bg-white/50 p-8 md:p-10 rounded-3xl border border-brown/10 h-full" data-id="element-162">
            <h3 className="text-3xl mb-8 text-brown/60" data-id="element-163">
              Esto NO es para vos si...
            </h3>
            <ul className="space-y-6" data-id="element-164">
              {notFor.map((item, i) => <li key={i} className="flex items-start space-x-4" data-id="element-165">
                  <div className="bg-red-100 p-1 rounded-full mt-1 flex-shrink-0" data-id="element-166">
                    <X className="w-5 h-5 text-red-500" strokeWidth={3} data-id="element-167" />
                  </div>
                  <span className="text-lg text-brown/60" data-id="element-168">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}